import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { colors, fonts, useMediaQuery } from "../../../Styles";
import { NewInput, CheckBox, CheckStyles } from "../..";
import { DataObj, labelToKeyMap, Params, ReportTemplate } from "../../../Definitions/valueTypes";

interface Lvl1_Props {
  templateData?: ReportTemplate
  onTemplateDataChange: (data: ReportTemplate) => void
}

export default function TemplateModalLvl1({ templateData, onTemplateDataChange}:Lvl1_Props) {
  const {t} = useTranslation()
  const mobileXs = useMediaQuery(`(max-width: 690px)`);
  
  // Template Name
  const _templateName = useMemo(() => { return templateData && templateData.name ? templateData.name : undefined}, [templateData])
  
  // Data Levels
  const dataLevels = useMemo(() => {
    const _dataLevels: Params[] = [
      "animalId",
      "animalGroupId",
      "systemId"
    ] as Params[]

    return _dataLevels.map((param, index) => {
      const label = Object.entries(labelToKeyMap).find(([_, key]) => key === (param as any))?.[0];

      return (
        <CheckBox 
          key={index} 
          text={t(`params.${label}`, {defaultValue: `${label}`})}
          checkStyle={CheckStyles.blue} 
          isChecked={templateData && templateData.dataLevel === param as unknown as DataObj}
          onChange={() => onTemplateDataChange({ ...templateData, templateId: templateData?.templateId || 0, dataLevel: param as unknown as DataObj })}
        />
      )
    })

  }, [onTemplateDataChange, t, templateData])

  return (
    <div style={{display: "flex", flexDirection: "column", gap: "20px"}}>
      <div style={{display: "grid", gap: "10px", margin: "0 auto", gridTemplateColumns: mobileXs ? "1fr" : "repeat(2, 1fr)", gridTemplateRows: "1fr"}}>
        <div style={{gridArea: "1/1/2/2"}}>
            <NewInput
              header={t("reportPages.reports.templateName", {defaultValue: "Template Name"})}
              onChange={(value) => onTemplateDataChange({...templateData, templateId: templateData?.templateId || 0, name: value})}
              valueOverrides={{ defaultValue: _templateName }}
            />
        </div>
        <div style={{gridArea: "1/2/2/3", display: mobileXs ? "none" : "block"}}>
          
      </div>
      </div>
<div style={{width: mobileXs ? "100%" : "590px", margin: "0 auto", boxSizing: "border-box"}}>
        <p style={{ ...fonts.header, ...fonts.textShadow, ...fonts.fontSize4, color: colors.greyLightTertiary, padding: "0px 0px 2px 10px" }}>{t("reportPages.reports.dataLevel", { defaultValue: "data level" })}</p>
        <div style={{height: "2px", width: mobileXs ? "100%" : "280px", backgroundColor: colors.blueDarkSecondary}}/>
        <div style={{paddingTop: "10px", maxHeight: "200px", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ width: "fit-content", display: "grid", gridTemplateColumns: mobileXs ? "1fr 1fr" : "1fr 1fr 1fr", gridTemplateRows: mobileXs ? "1fr 1fr" : "", columnGap: mobileXs ? "50px" : "100px", rowGap: "10px" }}>
            {dataLevels}
          </div>
        </div>
      </div>
    </div>
  )
}